import React from 'react'

const PrivacyPolicy = () => {
  return (
    <div className=''>
      <div className="container">
        {/* Add logos here */}
        <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}>
          <img
            src="https://static.wixstatic.com/media/5715af_a286bfb446374a96877a4193a1ef0933~mv2.png"
            alt="PAT Logo"
            style={{ width: '120px', marginRight: '20px', verticalAlign: 'middle' }}
          />
          <img
            src="https://static.wixstatic.com/media/77a25b_ec2fa92086954799bf72699afde7a666~mv2.png"
            alt="VMKG Logo"
            style={{ width: '200px', verticalAlign: 'middle' }}
          />
        </div>

       <div
  className="card"
  style={{
    background: "#fff",
    borderRadius: "16px",
    padding: "40px",
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto 40px",
    boxShadow: "0 6px 30px rgba(0,0,0,0.1)",
    fontSize: "16px",
    color: "#333",
    lineHeight: "1.7",
    textAlign: "left",
    overflowY: "auto",
    maxHeight: "100%",
    position: "relative"
  }}
>
  {/* Heading */}
  <h2
    style={{
      fontSize: "30px",
      fontWeight: "700",
      marginBottom: "20px",
      textAlign: "center",
      color: "#222"
    }}
  >
    Privacy Policy
  </h2>

  {/* Full Content */}
  <p style={{ marginBottom: "20px", color: "#555", fontSize: "17px" }}>
    We take your privacy seriously at HumanDesign Education Pvt Ltd. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our online assessment, i.e. Personal Assessment Test (PAT).
  </p>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>Information Collection:</h3>
  <p>
    When you use our Personal Assessment Test, we may collect personal information such as your name, email address, age, gender, and responses to the assessment questions.
    We may also gather non-personal information, including browser information, device type, and IP address for analytical purposes.
  </p>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>Use of Information:</h3>
  <p>
    The personal information collected is used to provide you with the Personal Assessment Test results and insights based on your responses.
    We may use non-personal information for statistical analysis, to improve our services, and for marketing purposes.
  </p>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>Information Protection:</h3>
  <p>
    We implement reasonable security measures to safeguard your personal information and prevent unauthorized access or disclosure.
    We do not sell, trade, or transfer your personal information to third parties without your consent, except as required by law.
  </p>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>Cookies:</h3>
  <p>
    We may use cookies and similar tracking technologies to enhance your user experience and collect information about how you use our website.
  </p>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>Third-Party Links:</h3>
  <p>
    Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these websites. 
    Please review their privacy policies before providing any personal information.
  </p>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>Your Consent:</h3>
  <p>
    By using our online Personal Assessment Test, you consent to the terms outlined in this Privacy Policy.
  </p>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>Updates to the Privacy Policy:</h3>
  <p>
    We reserve the right to update or modify this Privacy Policy. Any changes will be posted on this page.
  </p>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>Contact Us:</h3>
  <p>
    If you have any questions or concerns about our Privacy Policy or the use of your personal information, please contact us at{" "}
    <a href="mailto:reachus@victormanickam.com" style={{ color: "#396AA9", textDecoration: "none", fontWeight: "500" }}>
      reachus@victormanickam.com
    </a>.
  </p>

  <p style={{ marginTop: "20px", fontWeight: "500", color: "#444" }}>
    By using our online Personal Assessment Test, you acknowledge that you have read and understood this Privacy Policy and agree to its terms and conditions.
  </p>

  {/* Sticky footer button (optional) */}
  <div style={{
      position: "sticky",
      bottom: "0",
      background: "#fff",
      padding: "20px 0",
      textAlign: "center",
      borderTop: "1px solid #eee",
      marginTop: "20px"
    }}>
    {/* Uncomment if needed
    <button
      style={{
        background: "#396AA9",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        padding: "12px 28px",
        fontSize: "16px",
        fontWeight: "600",
        cursor: "pointer",
        transition: "0.3s"
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#FEBD16")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "#396AA9")}
    >
      Accept & Proceed
    </button> 
    */}
  </div>
</div>

      </div>
    </div>
  )
}

export default PrivacyPolicy
